export const LOADING_REQUEST_TRACKING = "LOADING_REQUEST_TRACKING";
export const SAVE_LOADING_REQUEST_TRACKING = "SAVE_LOADING_REQUEST_TRACKING";
export const GET_REQUEST_TRACKING = "GET_REQUEST_TRACKING";
export const FORM_FAIL = "FORM_FAIL";
export const REQUEST_TRACKING_FAIL = "REQUEST_TRACKING_FAIL";
export const LOADING_REQUEST_TRACKING_BY_ID = "LOADING_REQUEST_TRACKING_BY_ID";
export const GET_REQUEST_TRACKING_BY_ID = "GET_REQUEST_TRACKING_BY_ID";

